export default defineAppConfig({
    ui: {
        colors: {
            primary: 'chsc-indigo',
        },
        button: {
            slots: {
                base: 'font-montserrat rounded-[40px] font-bold',
                label: 'uppercase',
            },
            variants: {
                size: {
                    xxs: {
                        base: 'px-4 py-1.5',
                    },
                    xs: {
                        base: 'px-4 py-1.5',
                    },
                    md: {
                        base: 'px-6 py-2',
                    },
                    lg: {
                        base: 'px-8 py-3',
                    },
                    xl: {
                        base: 'px-12 py-4 max-[1025px]:text-sm',
                    },
                },
            },
            compoundVariants: [
                {
                    color: 'primary',
                    variant: 'outline',
                    class: 'ring-[2px] ring-(--ui-primary)/100 hover:bg-(--ui-primary)/100 hover:text-white',
                },
                {
                    color: 'secondary',
                    variant: 'outline',
                    class: 'text-white ring-[2px] ring-white/100 hover:bg-white/100 hover:text-chsc-indigo-500',
                },
            ],
            defaultVariants: {
                size: 'md',
            },
        },
        input: {
            slots: {
                base: 'rounded-[40px]',
            },
            variants: {
                outline: 'text-chsc-indigo-500 bg-(--ui-bg) ring ring-inset ring-(--ui-border-accented)',
                size: {
                    xl: {
                        base: 'px-8 py-4',
                    },
                },
            },
        },
        selectMenu: {
            slots: {
                base: 'rounded-[40px]',
            },
        },
    },
})
